import * as Color from "color"
import PptxGenJS, { Slide } from "pptxgenjs"
import { Decomposition } from "../debt-table"
import * as DebtUtils from "../utils"
import { ReportConfiguration } from "../../../configuration"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import {
	Placeholder,
	getPlaceholderChartBodyOptions
} from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import { LoanWithDecomposition } from "../../../../../model"

export function checkCapitalReimbursementSection(
	configuration: ReportConfiguration
): boolean {
	const capitalReimbursement = configuration.debt.capitalReimbursement
	return capitalReimbursement.globalCharts || capitalReimbursement.tables
}

export function createCapitalReimbursementSection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	childDecomposedLoans: any,
	years: number[],
	checked:string
): DocumentSection {
	const slides: Slide[] = []
	const slidesTitle = formatTitle("Remboursement capital", numbering)
	const capitalReimbursement = configuration.debt.capitalReimbursement
	const placeholderBody = getPlaceholderChartBodyOptions()
	const baseColor = new Color(configuration.table.header.backgroundColor)

		DebtUtils.includeDebtTable(
			pptx,
			slidesTitle,
			"management-report-debt-capital-reimbursement",
			Decomposition.CapitalReimbursement,
			childDecomposedLoans,
			years,
			configuration,
			checked
		)


	return { slides, title: slidesTitle }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/capital-reimbursement-generator/index.tsx